import api from '@/services/api'
import SecurityGroupActions from './actions-types'
import SecurityGroupMutations from './mutations-types'

export default {
  [SecurityGroupActions.GET_ALL_SECURITYGROUPS]({}, options) {
    return new Promise((resolve, reject) => {
      api.node.security
        .getSecurityGroups(options)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [SecurityGroupActions.SAVE_SECURITYGROUP]({ state }) {
    return new Promise((resolve, reject) => {
      let data = {}
      state.fields.forEach((item) => {
        // Omit an unspecified status so updates preserve the current value.
        if (item.name === 'active' && (item.value === null || item.value === undefined)) {
          return
        }

        data[item.name] = item.value
      })

      if (state.selectedSecurityGroup) {
        api.node.security
          .updateSecurityGroup(data, state.selectedSecurityGroup.security_group_id)
          .then((response) => {
            resolve(response.body)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      } else {
        api.node.security
          .createSecurityGroup(data)
          .then((response) => {
            resolve(response.body)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      }
    })
  },

  [SecurityGroupActions.UPDATE_SECURITYGROUP]({ state }, data) {
    return new Promise((resolve, reject) => {
      api.node.security
        .updateSecurityGroup(data, state.selectedSecurityGroup.security_group_id)
        .then((response) => {
          resolve(response.body)
        })
        .catch((error) => {
          reject(error.response.data)
        })
    })
  },

  [SecurityGroupActions.DELETE_SECURITYGROUP]({ state }) {
    return new Promise((resolve, reject) => {
      api.node.security
        .deleteSecurityGroup(state.selectedSecurityGroup.security_group_id)
        .then((response) => {
          resolve(response.body)
        })
        .catch((error) => {
          reject(error.response.data)
        })
    })
  },

  [SecurityGroupActions.GET_SECURITYGROUP]({ commit }, securityGroupId) {
    return new Promise((resolve, reject) => {
      api.node.security
        .getSecurityGroup(securityGroupId)
        .then((response) => {
          commit(SecurityGroupMutations.SET_SELECTED_SECURITYGROUP, response.data)
          resolve()
        })
        .catch((error) => {
          reject(error.response.data)
        })
    })
  },

  [SecurityGroupActions.GET_SECURITY_GROUPS_BY_NODE]({}, nodeId) {
    return new Promise((resolve, reject) => {
      api.node.security
        .getSecurityGroupsFromNode(nodeId)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [SecurityGroupActions.GET_SECURITY_GROUPS_BY_TENANT]({}, tenantId) {
    return new Promise((resolve, reject) => {
      api.node.security
        .getSecurityGroupsFromTenant(tenantId)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [SecurityGroupActions.GET_SECURITY_MARKS_BY_SECURITY_GROUP]({}, secGroupId) {
    return new Promise((resolve, reject) => {
      api.node.security
        .getSecurityMarksBySecurityGroup(secGroupId)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [SecurityGroupActions.GET_ALL_SECURITY_MARKS_BY_SECURITY_GROUP_USER]({}, secGroupId) {
    return new Promise((resolve, reject) => {
      api.node.security
        .getAllSecurityMarksBySecurityGroupUser(secGroupId)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [SecurityGroupActions.ADD_SECURITY_GROUP_NODE_RELATIONSHIP]({}, params) {
    return new Promise((resolve, reject) => {
      api.node.aspect
        .addAspectNodeRelationship(params.securityGroupId, params.nodeId, params.data)
        .then(() => {
          resolve()
        })
        .catch(() => reject())
    })
  },

  [SecurityGroupActions.REMOVE_SECURITY_GROUP_NODE_RELATIONSHIP]({}, params) {
    return new Promise((resolve, reject) => {
      api.node.aspect
        .removeAspectNodeRelationship(params.securityGroupId, params.nodeId)
        .then(() => {
          resolve()
        })
        .catch(() => reject())
    })
  }
}
